import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContragentService } from '@zaoblako/web/core/services/client/contragent.service';
import { BaseSingleSelectComponent } from '@zaoblako/web/shared/components/base-single-select/base-single-select.component';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import type { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import type { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import { Observable } from 'rxjs';

@Component({
  selector: 'crm-contragent-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, SpinnerComponent, SafeHtmlPipe],
  templateUrl: './contragent-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContragentSingleSelectComponent
  extends BaseSingleSelectComponent<ContragentFindInterface>
  implements OnChanges {
  public availableModule = 'BASIS';
  protected readonly entityCacheKind = 'contragent';

  @Input() public clientIds: number[] = [];
  @Input() public onlyWithSalaryControl = false;

  public constructor(private readonly contragentService: ContragentService) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.clientIds && !changes.clientIds.firstChange) ||
      (changes.onlyWithSalaryControl && !changes.onlyWithSalaryControl.firstChange)
    ) {
      this.firstLoad();
    } else {
      super.ngOnChanges(changes);
    }
  }

  public findById(id: number): Observable<ContragentFindInterface> {
    return this.contragentService.findById(id);
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<ContragentFindInterface>> {
    return this.contragentService.getAll({
      ...queryParams,
      clientIds: this.clientIds,
      onlyWithSalaryControl: this.onlyWithSalaryControl || undefined
    });
  }

  public toContragent(contragent: unknown): ContragentFindInterface {
    return contragent as ContragentFindInterface;
  }
}
